<template>
  <span
    class="softer tw:inline-flex tw:text-sm"
    data-testid="archived-content-label"
  >
    <span class="tw:mr-1 flex items-center justify-center">
      <BaseIcon icon="inventory" />
    </span>
    <span
      v-if="mediaRequestStatus === 'In Progress'"
      class="inline-block align-middle"
    >
      {{ getLocaleText("mention_detail_tv_radio.processing") }}
    </span>
    <span
      v-if="mediaRequestStatus === 'Completed'"
      class="inline-block align-middle"
    >
      {{ getLocaleText("mention_detail_tv_radio.archived") }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseIcon } from "shared/components/base";
import { getBroadcastMediaRequest } from "shared/services/mention";
import { type Nullable } from "shared/types";
import type { RadioClip, TvCaption } from "shared/types/mentions";

const props = defineProps<{
  mention: TvCaption | RadioClip;
}>();

const mediaRequestStatus = computed<Nullable<string>>(
  () => getBroadcastMediaRequest(props.mention)?.status ?? null
);
</script>
